export default "__VITE_ASSET__CXSwxuEr__"